import { useForm } from "@inertiajs/react";
import { Button } from "./Button";
import Swal from "sweetalert2";
import useAddSubscriber from "@/Hooks/useAddSubscriber";

export function Join({ className = "" }) {
  const { data, setData, reset } = useForm({
    email: "",
  });

  const { addSubscriber, isLoading, error } = useAddSubscriber();

  // Function to validate email format
  const validateEmail = (email) => {
    const regexPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regexPattern.test(email);
  };

  const setWithExpiry = (key, value, ttl) => {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the email is valid
    if (!validateEmail(data.email)) {
      // If email is not valid, show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Please enter a valid email address.",
        showConfirmButton: true,
        confirmButtonText: "Try Again",
      });
      return; // Stop the function from proceeding further
    }

    // If email is valid, proceed with adding the subscriber
    try {
      const response = await addSubscriber(data);
      if (response.response.data.error || response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.response.data.error,
          showConfirmButton: true,
          confirmButtonText: "Try Again",
          timer: 2000,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Success!",
          showConfirmButton: false,
          timer: 2000,
        });

        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
        setWithExpiry("subscribe_banner_hidden", true, thirtyDaysInMs);

        reset();
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Something went wrong",
        showConfirmButton: true,
        confirmButtonText: "Try Again",
        timer: 2000,
      });
    }
  };

  return (
    <div className="flex">
      <form action="" onSubmit={handleSubmit}>
        <div className="block gap-y-2">
          <input
            type="email" // Changing type to email for semantic correctness
            className="flex-grow h-[54px] text-black py-[14px] px-4 font-medium w-[50%] lg:w-[290px] rounded-[8px] rounded-tr-[0px] rounded-br-[0px] text-[14px] lg:text-[16px]"
            value={data.email}
            onChange={(e) => setData("email", e.target.value)}
            // style={{ borderRadius: "8px 0 0 8px" }}
            placeholder="Email Address"
            required
          />
          <Button
            type="submit"
            className="inline-block justify-center items-center w-[50%] lg:w-[185px] h-[54px] rounded-[8px] rounded-tl-[0px] rounded-bl-[0px] font-normal text-[14px] lg:text-[16px]"
            // style={{ borderRadius: "0 8px 8px 0", width: "200px" }}
          >
            Join the Community
          </Button>
        </div>
      </form>
    </div>
  );
}
